export const getNamewithTrimmed = (name, trimLength) => {
    if (!name) return '';
  
    const trimmed = name.trim();
  
    return trimmed.length > trimLength
      ? trimmed.slice(0, trimLength) + '...'
      : trimmed;
  };
  
export const validationOnCharLength = (name, trimLength) => {
    if (name.length > trimLength) {
        return false;
    }
    return true;    
  };
  export const disableItem =(item)=>{
    const disableItem = [
      "make a copy",
      "move to",
      "file information",
      "share",
      "get link",
      "open",
      "download",
      "preview",

      "activity",
      "description",
      "add description",
      "settings",
      "messages",
      "notifications",
    ]
    return disableItem.includes(item);
  }